module.exports = __webpack_public_path__ + "static/media/landingPageVideoTop.9d86746d.png";